(($, Drupal) => {
  "use strict";

  Drupal.behaviors.questionModalMathTabsRestrictions = {
    attach(context) {
      const mathSelector = ".core-questions--math";
      const feedbackSelector = ".quiz-question-feedback";
      const indicatorSelector = ".carousel-indicators__indicator";

      // Check for Math questions and disable indicators
      if ($(mathSelector).length > 0) {
        $(`${indicatorSelector}:not(:first-child)`).addClass(
          "carousel-indicators__indicator--disabled"
        );

        if ($(feedbackSelector).length > 0) {
          $(`${indicatorSelector}--disabled`).removeClass(
            "carousel-indicators__indicator--disabled"
          );
        }
      }

      // Handle button clicks for opening specific slides
      const buttonActions = [
        { selector: ".btn--carousel-model-answer", targetIndex: 2 },
        { selector: ".btn--carousel-video", targetIndex: 3 },
        { selector: ".btn--carousel-quiz", targetIndex: 4 },
      ];

      buttonActions.forEach(({ selector, targetIndex }) => {
        $(selector, context).on("click", (e) => {
          e.preventDefault();
          $(`${indicatorSelector}:nth-child(${targetIndex})`).trigger("click");
        });
      });
    },
  };
})(jQuery, Drupal);
